export default {
  'appointment-request.status': 'Status Ihrer Terminanfrage',
  'appointment-request.send': 'Anfrage senden',
  'appointment-request.title': 'Terminanfrage | {appointmentType}',
  'appointment-request.group-appointment': 'Gruppentermin',
  'appointment-request.group-appointment.description':
    'Bei dem angefragten Termintyp handelt es sich um einen Gruppentermin.',
  'appointment-request.group-appointment.quota.description':
    'Die maximale Teilnehmeranzahl ist beschränkt auf {quota} Teilnehmer.',
  'cancel-appointment-request.title': 'Terminanfrage stornieren',
  'appointment-request-cancel': 'Terminanfrage stornieren',
  'cancel-appointment-request.reason':
    'Bitte sagen Sie uns warum Sie Ihre Terminanfrage stornieren möchten',
  'appointment-request.reason-for-cancellation': 'Begründung der Stornierung: {reason}',
  'appointment-request.reason-for-rejection': 'Grund: {reason}',
  'appointment-request.reason-for-archived': 'Gründe für die Archivierung: {reason}',
  'appointment-request.reason-for-cancellation.missing': 'Keine Begründung angegeben',

  'appointment-cannot-be-cancelled-online':
    'Dieser Termin kann nicht mehr storniert werden. Stornierungen müssen spätestens {timeInterval} vor Terminbeginn erfolgen',

  'appointment-request-account-verification': 'Terminbuchung bestätigen',
  'appointment-request-account-verification.description':
    'Ihre Terminanfrage wurde erfolgreich erstellt. Bitte bestätigen Sie Ihr Konto, um die Terminanfrage abzuschließen. Wir haben Ihnen eine E-Mail an die E-Mail-Adresse {email} geschickt. Bitte beachten Sie, dass Ihre Terminanfrage noch 60 Minuten gültig ist. Sollten Sie Ihr Konto nicht verifizieren, wird diese automatisch gelöscht.',

  'appointment-request': 'Terminanfrage',
  'appointment-request.addition': 'Ihre Anmerkungen',
  'appointment-request.appointments': 'Verknüpfte Termine',
  'appointment-request.changed': 'Ihre Terminanfrage wurde geändert',
  'appointment-request.changed.description':
    'Ihre Anfrage wurde zu {appointmentType}, {facility} geändert. Bitte überprüfen und bestätigen Sie die neue Terminanfrage.',
  'appointment-request.description':
    'Sie werden nach Abschluss der Terminanfrage eine E-Mail von der ausgewählten Einrichtung erhalten, von der aus Sie Ihre Terminbuchung abschließen können.',
  'appointment-request.manual':
    'Ihre Terminanfrage wird von der Einrichtung manuell bearbeitet. Die Antwort auf Ihre Anfrage kann dadurch einige Tage dauern.',
  'appointment-request.confirm': 'Terminanfrage senden',
  'appointment-request.error': 'Terminanfrage fehlgeschlagen',
  'appointment-request.success': 'Terminanfrage gesendet',
  'appointment-request.success.description':
    'Sie können Ihre Terminanfragen sowie bereits gebuchte Termine in der Terminübersicht einsehen und verwalten.',
  'appointment-request.error.description':
    'Bei der Terminanfrage ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'appointment-request.error.slot-taken': 'Terminanfrage fehlgeschlagen',
  'appointment-request.error.slot-taken.description':
    'Dieser Termin steht leider nicht mehr zur Verfügung. Bitte wählen Sie einen anderen Termin aus, um die Buchung erfolgreich abzuschließen.',

  'appointment-request.info.account-verified-on-other-device': 'Login benötigt',
  'appointment-request.info.account-verified-on-other-device.description':
    'Es sieht so aus als hätten Sie ihren Account auf einem anderen Gerät verifiziert. Bitte loggen Sie sich erneut ein.',
  'appointment-request.linked-appointment-cancelled.tooltip.single':
    'Der verknüpfte Termin wurde storniert',
  'appointment-request.linked-appointment-cancelled.tooltip.multi': 'Enthält stornierte Termine',
  'appointment-request.linked-appointment-cancelled.status': 'Storniert',
};
